import styles from "./index.module.less";
import { Flex } from "antd";
import p2Img1 from "./imgs/p2_img1.png";
import p2Img2 from "./imgs/p2_img2.png";
import p3Img1 from "./imgs/p3_img1.png";
import p3Img2 from "./imgs/p3_img2.png";
import p3Img3 from "./imgs/p3_img3.png";
import P3Icon1 from "./imgs/p3_icon1.svg?react";
import P3Icon2 from "./imgs/p3_icon2.svg?react";
import P3Icon3 from "./imgs/p3_icon3.svg?react";
import classNames from "classnames";
import P4Img1 from "./imgs/p4_img1.png";
import P1Content from "@/components/P1Content";
import data from "../data";
import SVGIcon from "@/components/SVGIcon";
import banner from "./imgs/p1_bg.png";

// 图片和icon映射
const p2Imgs = [p2Img1, p2Img2];
const p3Imgs = [p3Img1, p3Img2, p3Img3];
const p3Icons = [<P3Icon1 />, <P3Icon2 />, <P3Icon3 />];

const p3List = data.p3.list.map((item, idx) => ({
  ...item,
  img: p3Imgs[idx],
  icon: p3Icons[idx],
}));

const MobileAIBeings = () => {
  return (
    <div className={styles.aiBeings}>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          link={data.p1.link}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <div className={styles.p2_title}>
            {data.p2.title}
            <br />
            <span>{data.p2.subtitle}</span>
          </div>
          <Flex
            align="start"
            justify="space-between"
            gap={".08rem"}
            className={styles.p2_imgs}
          >
            {p2Imgs.map((img, i) => (
              <div key={i} className={styles[`p2_img${i + 1}`]}>
                <img src={img} alt="P2" />
              </div>
            ))}
          </Flex>
          <Flex vertical className={styles.p2_texts}>
            {data.p2.desc.map((desc, i) => (
              <div className={styles.p2_desc} key={i}>
                {desc}
              </div>
            ))}
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_left}>
            <div className={styles.p3_title}>{data.p3.title}</div>
            <Flex vertical gap={".2rem"} className={styles.p3_list}>
              {p3List.map((item, index) => (
                <Flex
                  vertical
                  gap={'.08rem'}
                  key={index}
                  className={classNames(styles.p3_left_item)}
                >
                  <Flex align="center" gap={".08rem"}>
                    <SVGIcon icon={item.icon} width={20} />
                    <span className={styles.p3_left_text}>{item.anchor}</span>
                  </Flex>
                  <div className={styles.p3_left_desc}>{item.desc}</div>
                  <img
                    id={`feature-${item.anchor}`}
                    src={item.img}
                    key={index}
                  />
                </Flex>
              ))}
            </Flex>
          </div>
        </div>
      </div>
      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.p4_title}>
            {data.p4.title.split(data.p4.highlight)[0]}
            <br />
            <span>{data.p4.highlight}</span>
            {data.p4.title.split(data.p4.highlight)[1]}
          </div>
          <img className={styles.p4_img} src={P4Img1} />
        </div>
      </div>
    </div>
  );
};
export default MobileAIBeings;
